<template>
    <el-card>
        <el-row class="fiveStar__title">评价</el-row>
        <!-- 搜索 -->
        <el-row class="fiveStar__search">
            <div class="item">
                <span>rid:</span>
                <el-input style="width: 150px;" v-model.number="searchList.rid" clearable placeholder="请输入rid"></el-input>
            </div>
            <div class="item">
                <span>状态</span>
                <el-select v-model="searchList.status" filterable placeholder="请选择">
                    <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <span>渠道</span>
                <el-select style="width: 200px;" clearable v-model="searchList.channel" filterable placeholder="请选择">
                    <el-option v-for="item in channelList" :key="item.channelId" :label="item.name" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <span>国家</span>
                <el-select clearable style="width: 200px;" v-model="searchList.countryCode" filterable
                    placeholder="请选择">
                    <el-option v-for="item in countryList" :key="item.countryCode" :label="item.country"
                        :value="item.countryCode">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <span>时间</span>
                <el-date-picker v-model="timer" type="daterange" range-separator="至" start-placeholder="开始日期"
                    end-placeholder="结束日期" value-format="timestamp" @change="handleDateChange" clearable>
                </el-date-picker>
            </div>
            <el-button style="margin-left: 10px;" type="primary" @click="getList(1)">search</el-button>
        </el-row>
        <!-- 表格 -->
        <el-row>
            <el-table border :data="tableList">
                <el-table-column prop="id" label="ID" align="center">
                </el-table-column>
                <el-table-column prop="name" label="用户名称" align="center">
                </el-table-column>
                <el-table-column prop="channel" label="渠道" align="center">
                </el-table-column>
                <el-table-column prop="country" label="国家" align="center">
                </el-table-column>
                <el-table-column prop="createDate" label="上传时间" align="center">
                </el-table-column>
                <el-table-column prop="rid" label="上传人rid" align="center">
                </el-table-column>
                <el-table-column prop="imageUrl" label="上传图片" align="center">
                    <template slot-scope="scope">
                        <el-image :src="scope.row.imageUrl" style="width: 100px; height: 100px;"
                            :preview-src-list="[scope.row.imageUrl]" />
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="审核状态" align="center">
                    <template slot-scope="scope">
                        {{statusList.find(item => item.value === scope.row.status)?.label || ''}}
                    </template>
                </el-table-column>
                <el-table-column prop="operator" label="审核人" align="center">
                </el-table-column>
                <el-table-column prop="fixDate" label="审核时间" align="center">
                </el-table-column>
                <el-table-column label="操作" align="center" width="250" fixed="right">
                    <template slot-scope="scope">
                        <div class="btns">
                            <el-button v-if="scope.row.status == 0" type="primary"
                                @click="handleReports(scope.row, 1)">通过</el-button>
                            <el-button v-if="scope.row.status == 0" type="info"
                                @click="handleReports(scope.row, 2)">拒绝</el-button>
                            <el-button style="width: max-content;" v-if="scope.row.status == 2" type="primary"
                                @click="handleReports(scope.row, 1)">修改为通过</el-button>
                            <el-button style="width: max-content;" v-if="scope.row.status == 1" type="info"
                                @click="handleReports(scope.row, 2)">修改为拒绝</el-button>
                            <el-button type="success" @click="openDialog(scope.row)">备注</el-button>

                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <!-- 分页 -->
        <el-row>
            <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize"
                 @current-change="guaranteedHandleCurrentChange">
            </el-pagination>
        </el-row>
        <!-- 备注 -->
        <el-dialog title="备注" :visible.sync="dialogVisible" width="30%" @close="remarkDialogClose">
            <el-row>
                <span>备注人：{{ remarkPerson }}</span>
            </el-row>
            <el-input type="textarea" v-model="changeConfig.descText" placeholder="请输入备注" :rows="5"></el-input>
            <el-row style="margin-top: 20px;">
                <el-button type="info" @click="remarkDialogClose">取消</el-button>
                <el-button type="primary" @click="changeStatus">提交</el-button>
            </el-row>
        </el-dialog>
    </el-card>
</template>
<script>
export default {
    data() {
        return {
            dialogVisible: false,
            timer: null,
            searchList: {
                rid: null,
                status: null,
                page: 1,
                channel: null,
                countryCode: null,
                createStartDate: null,
                createEndDate: null,
            },
            pageSize: 30,
            total: 0,
            tableList: [],
            countryList: [],
            channelList: [],
            statusList: [
                { label: '审核中', value: 0 },
                { label: '审核成功', value: 1 },
                { label: '审核失败', value: 2 },
            ],
            changeConfig: {
                descText: '',
                status: 0,
                rid: null,
                id: null
            },
            remarkPerson: ''
        }
    },
    created() {
        this.getChannel()
        this.getCountryCode()
        this.getList(1)
    },
    methods: {
        handleDateChange(val) {
            if (val) {
                this.searchList.createStartDate = val[0] / 1000
                this.searchList.createEndDate = val[1] / 1000
            } else {
                this.searchList.createStartDate = null
                this.searchList.createEndDate = null
            }
        },
        // 获取数据列表
        async getList(page) {
            if (page) {
                this.searchList.page = page
            }
            const { data: res } = await this.$axios({
                method: 'post',
                url: this.$store.getters.path.five_star_query,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                },
                data: {
                    ...this.searchList,
                },
            })
            if (res.code === 0 || res.status === 0) {
                this.tableList = res.data.data
                this.total = res.data.total
            } else {
                this.$message.error(res.msg || res.message)
            }
        },
        handleReports(row, type) {
            this.changeConfig.id = row.id
            this.changeConfig.rid = row.rid
            this.changeConfig.descText = ''
            this.changeConfig.status = type
            this.changeStatus();
        },
        remarkDialogClose() {
            this.dialogVisible = false
            this.remarkPerson = ''
            this.changeConfig = {
                descText: '',
                status: 0,
                rid: null,
                id: null
            }
        },
        openDialog(row) {
            this.changeConfig.id = row.id
            this.changeConfig.rid = row.rid
            this.changeConfig.status = row.status
            this.changeConfig.descText = row.descText
            this.remarkPerson = row.remarkor
            this.dialogVisible = true
        },
        guaranteedHandleCurrentChange(page) {
            this.getList(page)
        },
        async changeStatus() {
            const { data: res } = await this.$axios({
                method: 'GET',
                url: this.$store.getters.path.five_star_review,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                    ...this.changeConfig,

                },
            })
            if (res.code != 0) {
                return this.$message.error(res.msg)
            } else {
                this.$message.success('操作成功')
                this.remarkDialogClose()
                this.getList()
            }
        },
        // 获取渠道选项
        async getChannel() {
            const { data: res } = await this.$axios({
                method: 'POST',
                url:
                    this.$store.getters.path.channelList +
                    '?username=' +
                    this.$store.getters.username +
                    '&token=' +
                    this.$store.getters.token,
            })

            if (res.code != 0) {
                return this.$message.error(res.msg)
            } else {
                this.channelList = [
                    { channelId: -1, name: 'all', value: 'all' },
                    ...res.data,
                ]
            }
        },
        // 获取国家选项
        async getCountryCode() {
            const { data: res } = await this.$axios({
                method: 'POST',
                url:
                    this.$store.getters.path.normal_country +
                    '?username=' +
                    this.$store.getters.username +
                    '&token=' +
                    this.$store.getters.token,
            })

            if (res.code != 0) {
                return this.$message.error(res.msg)
            } else {
                this.countryList = res.data.countryList
            }
        },
    },
}
</script>
<style scoped lang="scss">
.fiveStar {
    &__title {
        font-size: 28px;
        font-weight: 700;
        margin-bottom: 20px;
    }

    &__search {
        display: flex;
        flex-wrap: wrap;
        gap: 15px;

        span {
            font-size: 20px;
            font-weight: 600;
            margin-right: 15px;
        }

        .searchBtn {
            margin-left: 10px;
        }
    }
}

.btns {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;

    :deep(.el-button) {
        width: 80px;
        margin-left: 0;
    }
}
</style>
